import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveLayout from '../../components/common/ResponsiveLayout';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import { FeatureFlags } from '../../flags';
import { KEYSTONE_REDIRECT_URL } from '../../config';
import { OverviewProvider, Overview } from '@brightmls/nextgen.lae.overview';
import { useOverviewConfig } from './useOverviewConfig';
import { CatchupSync } from '../../components/catchup-sync';
import { useCatchupSync } from '../../hooks/useCatchupSync';

const OverviewWrapper: React.FC = () => {
  const { hasFeature } = useFeatureFlags();
  const showNewOverview = hasFeature(FeatureFlags.NGW_OVERVIEW);
  const { overviewConfig, overviewServices } = useOverviewConfig();
  const { isCatchupActive } = useCatchupSync();

  useEffect(() => {
    if (!showNewOverview) {
      window.location.href = `${KEYSTONE_REDIRECT_URL}`;
    }
  }, [showNewOverview]);

  if (!showNewOverview) {
    return (
      <ResponsiveLayout>
        <Box sx={{ textAlign: 'center', maxWidth: '600px', p: 3 }}>
          <Typography variant="h4" gutterBottom>
            Redirecting to Listing Management...
          </Typography>
        </Box>
      </ResponsiveLayout>
    );
  }

  if (isCatchupActive) {
    return (
      <ResponsiveLayout>
        <CatchupSync />
      </ResponsiveLayout>
    );
  }

  return (
    <OverviewProvider
      config={overviewConfig}
      services={overviewServices as any}
    >
      <Overview />
    </OverviewProvider>
  );
};

export default OverviewWrapper;
